app.controller(
    'DownloadController', ['$http', '$location', '$rootScope', '$scope', '$timeout', '$stateParams', 'ExplorerService', 'Upload', '$sce', '$state', 'TranslateService', DownloadController]
);
function DownloadController($http, $location, $rootScope, $scope, $timeout, $stateParams, ExplorerService, Upload, $sce, $state, TranslateService) {
    var vm = this;
    vm.modalObject = {};
    $scope.textEntered = null;
    $scope.selectedItem = null;
    $scope.explorerModel = null;
    $scope.explorerPath = null;
    $scope.count = 0;
    $scope.progress = "";
    $scope.list = [
    ];
    $scope.langs = [
    ];

    $scope.files = null;

    $scope.showOption = function (item, $event) {
        $event.stopPropagation();
        $scope.selectedItem = $scope.selectedItem === item ? null : item;
    };
    $scope.close = function () {
        if (!($scope.modalNewFolder || $scope.modalUpload || $scope.modalRename))
            $scope.selectedItem = null;
    };
    $scope.showOptionLangs = function (item) {
        var current = item.option;
        angular.forEach($scope.langs, function (itm) {
            itm.option = false;
        });
        item.option = !current;
    };
    $scope.showOptionFiles = function (item) {
        var current = item.option;
        angular.forEach($scope.files, function (itm) {
            itm.option = false;
        });
        item.option = !current;
    };
    $scope.sortType = 'name'; // set the default sort type
    $scope.sortReverse = false;  // set the default sort order
    $scope.showFolders = false;
    $scope.showLang = false;

    $scope.openFolder = function () {
        $scope.showFolders = true;
        $scope.showLang = false;
        console.log('@folder', $scope.showFolders);
        console.log('@lang', $scope.showLang);
    };
    $scope.openLang = function () {
        $scope.showLang = true;
        console.log('@folder', $scope.showFolders);
        console.log('@lang', $scope.showLang);
    };
    $scope.closeFolder = function () {
        $scope.showLang = false;
        $scope.showFolders = false;
        console.log('@folder', $scope.showFolders);
        console.log('@lang', $scope.showLang);
    };
    $scope.modalNewFolder = false;
    $scope.modalUpload = false;
    $scope.modalRename = false;
    $scope.folderName = null;
    $scope.addFolderModal = function (name) {
        name = name.trim();
        var path = name;
        if ($stateParams.path !== undefined && name !== '')
            path = $stateParams.path + "/" + name;

        if (path !== '') {
            ExplorerService.Create(path)
                .then(function (message) {
                    $scope.addFolder(name);
                    $scope.modalNewFolder = false;
                    $scope.folderName = null;
                    //$location.url("/download?path=" + $stateParams.path);
                });
        }
    };
    $scope.openModal = function () {
        if ($scope.showFolders && $scope.showLang) {
            $scope.modalNewFolder = false;
        } else {
            $scope.modalNewFolder = true;
        }
    };
    $scope.addFolder = function (name) {
        $scope.explorerModel.itemList.unshift({ Name: name, Date: (new Date()), Size: '0 B', IsFile: '0' });
    };

    $scope.openModalName = function (name) {
        if (name === 'new') {
            $scope.modalNewFolder = true;
            setTimeout(function () {
                angular.element('#modalNewFolderInput').focus();
            });
        } else if (name === 'upload') {
            $scope.modalUpload = true;
            $scope.files = null;
            $scope.progress = "";
            //setTimeout(function () {
            //    angular.element('#newupload').trigger('click');
            //});
        }
        else if (name === 'rename') {
            $scope.modalRename = true;
            $scope.files = null;
            $scope.progress = "";
            setTimeout(function () {
                angular.element('#modalRenameInput').focus();
            });
        }
    };

    $scope.openDelete = function (l, $event) {
        vm.modalObject.l = l;
        vm.modalObject.event = $event;
        $scope.modalDelete = true;
        $event.stopPropagation();
    };

    $scope.deleteDir = function () {
        $scope.remove(vm.modalObject.l, vm.modalObject.event);
        $scope.modalDelete = false;
    };

    initController();

    function initController() {
        TranslateService.use($rootScope.LangForInterface);

        if ($stateParams.path !== undefined)
            load($stateParams.path);
        else
            load("");
    }

    $scope.remove = function (item, $event) {
        $event.stopPropagation();

        var path = item.Name;
        if ($stateParams.path !== undefined)
            path = $stateParams.path + "/" + item.Name;
        ExplorerService.Remove(path)
            .then(function (model) {
                $scope.selectedItem = null;

                for (var i = $scope.explorerModel.itemList.length - 1; i >= 0; i--) {
                    if ($scope.explorerModel.itemList[i].Name === item.Name && $scope.explorerModel.itemList[i].IsFile === item.IsFile) {
                        $scope.explorerModel.itemList.splice(i, 1);
                    }
                }

                countresult();
            });
    };

    $scope.rename = function (item, $event) {
        console.log(item.Name);
        $event.stopPropagation();
        $scope.textEntered = item.Name;
        $scope.openModalName('rename');
    };

    $scope.download = function (name, $event) {
        $event.stopPropagation();
        var path = name;
        if ($stateParams.path !== undefined)
            path = $stateParams.path + "/" + name;
        ExplorerService.Download(path, "application/octet-stream")
            .then(function (response) {
                $scope.selectedItem = null;
            }, function (response) {
                if (response.status > 0) {
                    $scope.errorMsg = response.status + ': ' + response.data;
                }
            }, function (evt) {
                console.log(evt);
                $scope.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total)) + "%";
                console.log($scope.progress);
            }
            );
    };

    // [Lam Hong 11-Mar-2022] LVCG-77: [BO INTERFACE] [INDESIGN EXPORTS LIST] Order function is NOT working
    $scope.vieworgoto = function (isFile, name, $event) {
        if (isFile == 0) {
            $scope.goto(name);
        } else if (isFile == 1) {
            $scope.view(name, $event);
        }
    }
    // END

    $scope.view = function (name, $event) {                
        $event.stopPropagation();
        if (name.includes(".indd") !== -1) {
            $scope.download(name, $event);
        }
        else {
            var path = name;
            if ($stateParams.path !== undefined)
            path = $stateParams.path + "/" + name;
            ExplorerService.Download(path, "application/pdf");
        }        
    };

    $scope.goto = function (folder) {
        var path = folder;
        if ($stateParams.path !== undefined)
            path = $stateParams.path + "/" + folder;

        $location.url("/download?path=" + path);
    };

    $scope.deleteUploadFile = function (index) {
        $scope.files.splice(index, 1);
    };

    // Get called when user drag & drop files. Need to run $scope.$apply()
    $scope.addUploadFilesByDragDrop = function (files) {
        const filesArray = Object.keys(files).map(function (key) {
            return files[key];
        });

        $scope.addUploadFiles(filesArray, true);
    };

    // Get called when user select files from dialog window
    $scope.addUploadFiles = function (files, runApply) {
        if (files === undefined) { return; }
        if ($scope.files === null) { $scope.files = []; }

        let i;
        const compareFileName = function (x) {
            return x.name === files[i].name;
        };

        for (i = 0; i < files.length; i++) {
            // Check if user already select the file
            const filePosition = $scope.files.findIndex(compareFileName);

            if (filePosition === -1) {
                $scope.files.push(files[i]);
            } else {
                // Same file name, get the latter file
                $scope.files[filePosition] = files[i];
            }
        }

        if (runApply) { $scope.$apply(); }
    };

    //$scope.refreshUploadList = function (files) {
    //    $scope.files = files;
    //}

    $scope.renameFolder = function (item, newname) {
        var path = item.Name;
        if ($stateParams.path !== undefined) {
            path = $stateParams.path + "/" + item.Name;
            newname = $stateParams.path + "/" + newname;
        }

        if (path && newname) {
            ExplorerService.Rename(path, newname)
                .then(function (response) {
                    $timeout(function () {
                        $scope.result = response.data;
                        $scope.modalRename = false;
                        initController();
                    });
                }, function (response) {
                    if (response.status > 0) {
                        $scope.errorMsg = response.status + ': ' + response.data;
                    }
                }, function (evt) {
                    $scope.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total)) + "%";
                    console.log($scope.progress);
                });
        }
    };

    $scope.uploadFiles = function () {
        var path = "";
        if ($stateParams.path !== undefined)
            path = $stateParams.path + "/";

        if ($scope.files && $scope.files.length) {
            // Filter PDF files only
            let pdfFiles = [];
            $scope.files.forEach(file => {
                if (file.type === "application/pdf") { pdfFiles.push(file); }
            });
            if (pdfFiles.length === 0) { return; }

            ExplorerService.Upload(path, pdfFiles)
                .then(function (response) {
                    $timeout(function () {
                        $scope.result = response.data;
                        $scope.modalUpload = false;
                        $scope.files = [];
                        initController();
                    });
                }, function (response) {
                    if (response.status > 0) {
                        $scope.errorMsg = response.status + ': ' + response.data;
                    }
                }, function (evt) {
                    $scope.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total)) + "%";
                });
        }
    };

    function countresult() {
        $scope.count = $scope.explorerModel.itemList.length;
    }

    function load(path) {
        ExplorerService.GetIndex(path)
            .then(function (model) {
                $scope.explorerModel = model.data;
                if (path !== "") {
                    var paths = path.split('/');
                    var js = [];
                    var curr = "";
                    for (var i = 0; i < paths.length; i++) {
                        if (curr !== "")
                            curr += "/";
                        curr += paths[i];
                        let item = {
                            'path': curr,
                            'name': paths[i]
                        };
                        js.push(item);
                    }
                    $scope.explorerPath = js;
                    $scope.files = js;
                }

                countresult();
            });
    }
}